import React, { useState } from 'react';
import { FlightButton } from '@flybits/design-system';
import { TTimelineBoxProps } from 'pages/ExperienceCanvas/types';
import TouchpointEditorCard from 'components/Shared/TouchpointEditorCard/TouchpointEditorCard';
import FilesHistoryIcon from 'pages/ExperienceCanvas/assets/icons/FilesHistoryIcon';
import UploadContextDataIcon from 'pages/ExperienceCanvas/assets/icons/UploadContextDataIcon';
import FlowFileUpload from '../FlowFileUpload/FlowFileUpload';
import FlowContextDataSlideOut from '../FlowContextDataSlideOut/FlowContextDataSlideOut';
import './FlowUploadContextDataBox.scss';

const MAIN_CLASS = 'flow-upload-context-data-box';
const CLASSES = {
  BUTTON_LABEL: `${MAIN_CLASS}__button-label`,
  FILE_UPLOAD_WRAPPER: `${MAIN_CLASS}__file-upload-wrapper`,
};

const FlowUploadContextDataBox = ({ timelineIndex }: TTimelineBoxProps) => {
  const [isSlideOutOpen, setIsSlideOutOpen] = useState(false);

  const toggleSlideOut = () => setIsSlideOutOpen((prev) => !prev);

  const buttonLabel = (
    <div className={CLASSES.BUTTON_LABEL}>
      <FilesHistoryIcon />
      See upload history
    </div>
  );

  return (
    <TouchpointEditorCard
      className={MAIN_CLASS}
      title="Upload Context Data"
      icon={UploadContextDataIcon}
      timelineIndex={timelineIndex}
      subtitle="Providing your own data files enables personalized marketing experiences and precise audience targeting."
    >
      <div>
        <div className={CLASSES.FILE_UPLOAD_WRAPPER}>
          <FlowFileUpload allowedTypes={['text/csv']} />
        </div>
        <FlightButton label={buttonLabel} onClick={toggleSlideOut} theme="secondary" />
        <FlowContextDataSlideOut isOpen={isSlideOutOpen} onClickClose={toggleSlideOut} />
      </div>
    </TouchpointEditorCard>
  );
};

export default FlowUploadContextDataBox;
